import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Injector, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, ControlValueAccessor, UntypedFormControl, FormControlDirective, FormControlName, FormGroupDirective, NgControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
    selector: "db-datepicker",
    templateUrl: "./db-datepicker.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DbDatePickerComponent),
            multi: true
        }
    ],
    styles: [
        `
                 :host {
                     position: relative;
                 }
                 :host .datepicker-toggle-no-label {
                     position: absolute;
                     top: 0.9rem;
                     right: 0.8rem;
                 }
                 :host .datepicker-toggle {
                     position: absolute;
                     top: 2.2rem;
                     right: 0.8rem;
                 }
                 `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DbDatePickerComponent implements OnInit, ControlValueAccessor {
    @Input() required: boolean;
    @Input() label: string;
    @Input() fullWidth: boolean;
    @Input() placeholder: string;
    @Input() disabled: boolean;

    _required: boolean;

    formControl: UntypedFormControl;
    @Output() onchange: any = new EventEmitter();

    constructor(private cd: ChangeDetectorRef, public injector: Injector) { }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl);
        if (ngControl instanceof FormControlName) {
            this.formControl = this.injector.get(FormGroupDirective).getControl(ngControl);
        } else {
            this.formControl = (ngControl as FormControlDirective).form as UntypedFormControl;
        }

        this._required = this.formControl.validator != null && this.formControl.validator({} as AbstractControl)?.required;
    }





    onChange: any = val => {
        this.onchange.emit(val);
    };

    addEvent(input, event) {
        this.onChange(event.target.value);
    }

    onTouch: any = () => { };

    @Input("value") _value;
    set value(value: string) {
        this._value = value;
        this.onChange(value);
        this.onTouch(value);
    }
    get value() {
        return this._value;
    }

    writeValue(value: any): void {
        if (!this.value) this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }
    registerOnTouched(fn: any): void {
        this.onTouch = fn
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cd.markForCheck();
    }



}
